export enum CommitAction {  
  listAndDic = 1,
  dicOnly = 2,
  none = 3
}
